import {DataMappingState} from './DataMappingTypes';

const DEFAULT_DATA_MAPPING_STATE: DataMappingState = {
  mappings: [],
  resultSchema: null,
};

export default function getDefaultDataMappingState(): DataMappingState {
  return {...DEFAULT_DATA_MAPPING_STATE};
}
